import React from 'react';
import HeroSection from './HeroSection';
import InfoSection from './InfoSection';
import TestimonialSection from './TestimonialSection';
import BenfitSection from './BenfitSection';
import CounselingSection from './CounselingSection';
import Social from './Social';
import NameText from './name_text';
import Footer from '../Footer';
import BannerStudentImage from '../../assets/tutor_web_student_banner.jpg';
import NavBar from '../Navbar';

const StudentLanding = () => {
  return (
    <>
      <main className="">
        <NavBar activeTab="student" />
        <div className="wrapper">
          <HeroSection activeTab="student" />
          <InfoSection activeTab="student" />
        </div>
        <TestimonialSection activeTab="student" />
        <BenfitSection activeTab="student" />
        <section className="py-8 flex justify-center items-center">
          <img
            src={BannerStudentImage}
            alt="Student Banner"
            className="w-[350px] md:w-[400px] lg:w-[600px] xl:w-[1200px] h-auto object-cover mx-8"
          />
        </section>
        <Social activeTab="student" />
        <CounselingSection activeTab="student" />
        <NameText />
        <Footer />
      </main>
    </>
  );
};

export default StudentLanding;